import React from 'react';
import { X } from 'lucide-react';

// Modal chico que se abre POR ENCIMA de otro modal (z-70): alta rápida de
// producto/categoría desde el formulario de factura.
export default function MiniModal({ title, onClose, children }) {
  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-[70] p-4" onClick={onClose}>
      <div className="bg-white rounded-xl shadow-lg w-full max-w-xs p-4" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-3">
          <h3 className="font-semibold text-slate-800 text-sm">{title}</h3>
          <button type="button" onClick={onClose} className="text-slate-400 hover:text-slate-600">
            <X size={16} />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
